export interface INavbarActionItem {
    name: string;
    icon?: string;
    action: string;
}